import game from '../game/Game'
import { RECEIVE_HIGHSCORES, SELECT_HIGHSCORE } from '../actions/game'

export default function highscore(state = {}, action) {
  switch (action.type) {
    case RECEIVE_HIGHSCORES:
      Object.keys(action.scores).forEach(function(challengeId){
        action.scores[challengeId].forEach(function(score) {
          score.updated_at = new Date(score.updated_at)
        })
        action.scores[challengeId] = action.scores[challengeId].sort(function(a,b){
          return (a.totalMoves - b.totalMoves) || (a.updated_at - b.updated_at)
        })
        if (action.scores[challengeId].length > 0 ) action.scores[challengeId][0].selected = true
      })
      return action.scores
    case SELECT_HIGHSCORE:
      var scores = state[action.challengeId]
      scores.forEach(function(score) {
        score.selected = (score.name === action.name)
      })
      return Object.assign({}, state)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/highscore.js